<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar :title="`Students With Open Invoice`" />

        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table
                  dense
                  :headers="headers"
                  :items-per-page="rows.length"
                  :items="rows"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">{{ item.studentLocalId || "-" }}</td>
                      <td class="text-left">{{ item.studentName || "-" }}</td>
                      <td class="text-left">
                        <a
                          href="#"
                          class="font-weight-bold primary--text"
                          @click.prevent="viewCustomerProfile(item)"
                        >
                          {{ item.customerName || "-" }}
                        </a>
                      </td>
                      <td class="text-left">
                        <div v-if="item.fatherPhoneNumber">{{ item.fatherPhoneNumber | USPhoneNumber }}</div>
                        <div v-if="item.motherPhoneNumber">{{ item.motherPhoneNumber | USPhoneNumber }}</div>
                        <div v-if="!item.fatherPhoneNumber && !item.motherPhoneNumber">-</div>
                      </td>
                      <td class="text-left">{{ item.departmentName || "-" }}</td>
                      <td class="text-right">{{ item.invoiceCount }}</td>
                      <td class="text-left">{{ item.lastInvoiceDate | moment("MM/DD/YYYY") }}</td>
                      <td class="text-right red--text font-weight-bold">{{ openAmount(item) | currency }}</td>
                    </tr>
                  </template>
                  <template v-slot:no-data>
                    <div class="text-center py-4">
                      No students found with open invoices for selected date range.
                    </div>
                  </template>
                  <template v-slot:body.append="{ headers }" v-if="rows.length > 0">
                    <tr class="grey lighten-4 font-weight-bold">
                      <td :colspan="headers.length - 1" class="text-right">
                        TOTAL OPEN AMOUNT:
                      </td>
                      <td class="text-right red--text">{{ totalOpenAmount | currency }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import reportService from "@/modules/ReportView/service";

export default {
  components: { ReportViewBar },
  data() {
    return {
      isLoading: true,
      rows: [],
      sortBy: "openAmount",
      sortDesc: true,
      headers: [
        { text: "ID", align: "left", value: "studentLocalId" },
        { text: "STUDENT NAME", align: "left", value: "studentName" },
        { text: "CUSTOMER", align: "left", value: "customerName" },
        { text: "CONTACT #", align: "left", value: "fatherPhoneNumber", sortable: false },
        { text: "DEPARTMENT", align: "left", value: "departmentName" },
        { text: "INVOICE COUNT", align: "right", value: "invoiceCount" },
        { text: "LAST INVOICE", align: "left", value: "lastInvoiceDate" },
        { text: "OPEN AMOUNT", align: "right", value: "openAmount" },
      ]
    };
  },
  computed: {
    totalOpenAmount() {
      return this.rows.reduce((acc, row) => acc + this.openAmount(row), 0);
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    openAmount(item) {
      return Number(item.openAmount || 0);
    },
    loadData() {
      const params = {
        start: this.$route.query.start,
        end: this.$route.query.end
      };
      return reportService.getStudentOpenInvoice(params).then((response) => {
        this.rows = response.data || [];
        document.title = "Report - Students With Open Invoice";
        this.isLoading = false;
      }).catch(() => {
        this.rows = [];
        this.isLoading = false;
      });
    },
    viewCustomerProfile(item) {
      if (!item || !item.customerId) return;
      const routeData = this.$router.resolve({
        path: `/parents/${item.customerId}/profile`,
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style scoped>
@media print {
  .no-print {
    display: none !important;
  }
  .invoice-view {
    padding: 0 !important;
  }
}
.center {
  width: 100%;
  background-color: white;
}
</style>
